<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'app',
	watch: {
		$route: {
			handler(to) {
				if (to.name === 'yuejuan' || to.name.search('report') >= 0) {
					let name = null
					this.eventBus.$on('basicInformation', cb => (name = cb.userName || cb.markName))
					this.$watermark.set(name || decodeURI(to.query.userName))
				}
			},
			deep: true
		}
	}
}
</script>
[v-cloak] { display: none; }
<style>
* {
	margin: 0;
	padding: 0;
}
html,
body,
#app {
	width: 100%;
	height: 100%;
	overflow: auto;
	-webkit-text-size-adjust: none;
}
ul,
li {
	list-style: none;
}
</style>
